import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Toaster } from "sonner";
import { I18nProvider } from "@/contexts/I18nContext";

// Defense-in-depth: strip any "Made with Emergent" badge injected at runtime
if (typeof window !== "undefined") {
  const stripBadge = (root) => {
    try {
      const candidates = root.querySelectorAll(
        "a[href*='emergent.sh'], a[id*='emergent'], div[id*='emergent-badge'], div[class*='emergent-badge']"
      );
      candidates.forEach((el) => el.remove());
      // Any element with inner text exactly "Made with Emergent"
      const all = root.querySelectorAll("a, div, span, button");
      all.forEach((el) => {
        if (el.childElementCount === 0 && el.textContent && el.textContent.trim() === "Made with Emergent") {
          const container = el.closest("a, div") || el;
          container.remove();
        }
      });
    } catch {}
  };
  const run = () => stripBadge(document.body || document.documentElement);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  const observer = new MutationObserver(() => run());
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setInterval(run, 1000);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <I18nProvider>
      <App />
      <Toaster position="top-right" richColors closeButton />
    </I18nProvider>
  </React.StrictMode>,
);
